
import React from "react";
import { Check } from "lucide-react";

interface DocumentSaveSuccessProps {
  documents: any[] | undefined;
}

export const DocumentSaveSuccess: React.FC<DocumentSaveSuccessProps> = ({ documents }) => {
  if (!documents || documents.length === 0) return null;

  return (
    <div className="mt-4 p-3 bg-green-50 dark:bg-green-900/20 border border-green-200 dark:border-green-800 rounded-md text-green-800 dark:text-green-300">
      <div className="flex items-center gap-2">
        <Check className="h-5 w-5" />
        <p>
          Documents saved successfully. You can proceed to the next step.
        </p>
      </div>
    </div>
  );
};
